import React from 'react'
import {connect} from 'react-redux';
import { CONFIG } from '../../../../config';
import {cekCookies} from '../../../../actions';
import { Redirect } from 'react-router-dom'
import __ from 'lodash';
import accountManagement from '../../../../apis/accountManagement';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import Guru from '../../../../entity/Guru';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class AddGuru extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            isFetching: false,
            idGuru:null,
            idSekolah:null,
            namaGuru:null,
            usernameGuru:null,
            emailGuru:null,
            telponGuru:null,
            passwordGuru:null,
            statusGuru:null,
            fireRedirect: false
        }
    }

    async componentDidMount(){
        document.title = "Add Guru";
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            // this.fetchKelas();
        }
    }

    // HANDLE CHANGE INPUT
    namaGuruOnChange = (event) =>{
        this.setState({namaGuru: event.target.value})
    }
    usernameGuruOnChange = (event) => {
        this.setState({usernameGuru: event.target.value})
    }
    emailGuruOnChange = (event) => {
        this.setState({emailGuru: event.target.value})
    }
    telponGuruOnChange = (event) => {
        this.setState({telponGuru: event.target.value})
    }
    passwordGuruOnChange = (event) => {
        this.setState({passwordGuru: event.target.value})
    }
    statusGuruOnChange = (event) => {
        this.setState({statusGuru: event.target.value})
    }



    // HANDLE SUBMIT FORM REGISTRASI
    handleSubmit = async (event)=> {
        event.preventDefault();
        this.setState({isFetching: true});
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_REGIS_GURU , 
            {...Guru, 
                ["idSekolah"]: this.props.account.idSekolah,
                ["namaGuru"]: this.state.namaGuru,
                ["usernameGuru"]: this.state.usernameGuru,
                ["emailGuru"]: this.state.emailGuru,
                ["handphoneGuru"]: this.state.telponGuru,
                ["passwordGuru"]: this.state.passwordGuru,
                ["statusGuru"]: this.state.statusGuru,
            }).catch(function(error){})

        this.setState({isFetching: false});

        if(response.data.data.result) {
            alert(response.data.data.message)
            this.setState({ fireRedirect: true })
            // return <Redirect to='/guru'  />
        }
        else {
            alert(response.data.data.message)
        }
    }

    render(){        
        const { fireRedirect } = this.state
        if(fireRedirect){
            return( <Redirect to='/guru' />)
        }
        
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar /> 
                    <h4>Tambah Guru</h4> 
                    <div>
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>Nama Guru</label>
                                    <input type="text" className="form-control" value={this.state.namaGuru} onChange={this.namaGuruOnChange} placeholder="Nama Guru" required autoComplete="off"/>
                                </div>
                                <div className="col-md-4">
                                    <label>Username Guru</label>
                                    <input type="text" className="form-control" value={this.state.usernameGuru} onChange={this.usernameGuruOnChange} placeholder="Username Guru" required autoComplete="off"/>
                                </div>
                                <div className="col-md-4">
                                    <label>Password</label>
                                    <input type="password" className="form-control" value={this.state.passwordGuru} onChange={this.passwordGuruOnChange}  placeholder="Username Guru" required min="4"/>
                                </div>
                                
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>Email Guru</label>
                                    <input type="email" className="form-control" value={this.state.emailGuru} onChange={this.emailGuruOnChange} placeholder="Email Guru" required autoComplete="off"/>
                                </div>
                                <div className="col-md-4">
                                    <label>No Telpon</label>
                                    <input type="text" className="form-control" value={this.state.telponGuru} onChange={this.telponGuruOnChange}  placeholder="Nomor Telfon" required autoComplete="off"/>
                                </div>
                                
                                <div className="col-md-4">
                                    <label>Status Guru</label>
                                    <select className="form-control" value={this.state.statusGuru} onChange={this.statusGuruOnChange}  required>
                                        <option value="" selected>-- Pilih Status --</option>
                                        <option value="0">Aktif</option>
                                        <option value="1">Tidak Aktif</option>
                                    </select>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-danger"onClick={() => {this.setState({ fireRedirect: true })}}>
                                        <ArrowBackIosIcon fontSize="small"/>Batal</button>
                                    <input type="submit" value="Submit" className="btn btn-primary pull-right"/>
                                </div>   
                                
                            </div>
                        </form>
                    </div> 
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(AddGuru);